import { render, staticRenderFns } from "./about-company.vue?vue&type=template&id=a7ccc6a4&scoped=true&"
import script from "./about-company.vue?vue&type=script&lang=js&"
export * from "./about-company.vue?vue&type=script&lang=js&"
import style0 from "./about-company.vue?vue&type=style&index=0&id=a7ccc6a4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7ccc6a4",
  null
  
)

export default component.exports